


import TiwiMixin from '../mixins/TiwiMixin'
import ContentCard from './ContentCard'

import _ from 'lodash';

export default {
  mixins: [TiwiMixin],
  components: {
    ContentCard
  },
  props: {
    showInOverlay:{
      required: false,
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      current_page: null,

      allow_next_page: true,
      posts: [],
    }
  },
  mounted: function () {
    //this.getPosts(this.current_page);
    this.nextPage();
    this.enableInfiniteScroll();

  },
  computed: {

  },
  methods: {
   getPosts(page, append){

    if( append !== false )
      append = true; // indica se aggiungere i post in fondo o se reimpostare l'array

    var self = this;
    self.setLoading(true);

    var queries = '';

    if (this.wall_filter) {
      queries += `&filter_tax=${this.wall_filter.taxonomy}&filter_term=${this.wall_filter.id}`;
    }

    this.api.get('wall/getPosts?page=' + page + queries)
      .then((response) => {
        if (response.data.success) {
          self.current_page = response.data.page;

          self.posts = append ? [ ...self.posts, ...response.data.posts] : response.data.posts; 
          self.allow_next_page = self.current_page < response.data.max_num_pages;

          if(!self.allow_next_page)
            window.removeEventListener('scroll', self.handleScroll );
        }
        else {
          self.toast.error(response.data.message);
        }
      })
      .catch((error) => {
        self.toast.error('Errore nella richiesta');
      })
      .finally(() => self.setLoading(false))

   },
   nextPage: function(){

    if(!this.current_page)
      this.current_page = 1;
    else this.current_page++;

    this.getPosts(this.current_page);
   },

   enableInfiniteScroll: function(){
    
    var self = this;
    window.addEventListener('scroll', this.handleScroll )
   },

   handleScroll: _.debounce( function(){
    
    const wall = document.querySelector('#user-wall-post');
    var self = this;

   
    if (
        !self.loading && 
        self.allow_next_page && 
        self.current_page < 3 &&
        ( wall.getBoundingClientRect().bottom < window.innerHeight)
      ) {
      
      self.nextPage();
    }


   }, 250),
  },
  watch: {
    wall_filter() {
      this.posts = [];
      this.current_page = null;
      this.nextPage();
      // this.enableInfiniteScroll();
    }
  }
}
